<template>
  <p-dialog
    :visible="isOpen"
    header="Список деревьев"
    @update:visible="toggle"
    @hide="$emit('hide')"
    modal
    class="trees-modal"
  >
    <RecountTrees :preselectedPlot="preselectedPlot" />
  </p-dialog>
</template>

<script>
import RecountTrees from "./Recount__trees";

export default {
  name: "TreesModal",

  components: {
    RecountTrees,
  },

  props: {
    isOpen: Boolean,
    preselectedPlot: Object,
  },

  methods: {
    toggle(event) {
      this.$emit("update:is-open", false);
    },
  },
};
</script>

<style scoped>
.trees-modal::v-deep .p-dialog-content {
  height: 95vh;
  width: 95vw;
}
</style>
